module.exports = __webpack_public_path__ + "static/media/xp.7bb69e9b.svg";